import { gql } from '@apollo/client';

export const GET_HELP_ARTICLES = gql`
  query GetHelpArticles($kind: HelpArticleKind) {
    helpArticles(kind: $kind) {
      slug
      title
      summary
      area
      kind
      roles
      order
    }
  }
`;

export const GET_HELP_ARTICLE = gql`
  query GetHelpArticle($slug: String!) {
    helpArticle(slug: $slug) {
      slug
      title
      summary
      area
      kind
      roles
      order
      bodyMarkdown
      bodyHtml
    }
  }
`;

export const SEARCH_HELP_ARTICLES = gql`
  query SearchHelpArticles($query: String!, $kind: HelpArticleKind) {
    searchHelpArticles(query: $query, kind: $kind) {
      slug
      title
      summary
      area
      kind
      roles
      order
    }
  }
`;

export const ASK_HELP_QUESTION = gql`
  query AskHelpQuestion($question: String!) {
    askHelpQuestion(question: $question) {
      answer
      usedAi
      sources {
        slug
        title
        summary
        area
        kind
        roles
        order
      }
    }
  }
`;
